export function parseTagToKeyValue(tag) {
  const tList = tag.split(":");
  const value = Number(tList[tList.length - 1]);
  if (isNaN(value)) {
    return { [tList.join("")]: true };
  } else {
    return { [tList.slice(0, -1).join("")]: value };
  }
}

export function parseTagsToObject(tags) {
  return tags.reduce((acc, tag) => {
    return {
      ...acc,
      ...parseTagToKeyValue(tag),
    };
  }, {});
}
